module.exports = __webpack_public_path__ + "media/styles/images/png/inline-arrow-up-gray-light-9cad028a80a726d0ed7804ea2ab422ce.png";